up.compiler('.js-set_plan_chart_height', function (element) {
  // This function dynamically sets the height of the plans chart
  // based on the long term metric box's height, on its left.
  const setPlanChartHeightFrom = () => {
    const targetElement = document.querySelector('.js-expanded_stats')
    const height = targetElement.clientHeight
    const switchHeight = document.querySelector('#publication_analytics__plans__switch').clientHeight

    if (height) {
      element.style.height = `${height - switchHeight}px`
    } else {
      element.style.height = 'auto'
    }
  }

  setPlanChartHeightFrom()
  window.addEventListener('resize', setPlanChartHeightFrom)

  return function () {
    window.removeEventListener('resize', setPlanChartHeightFrom)
  }
})
